<template>
  <v-dialog scrollable v-model="config.status.active" max-width="800px">
    <v-card class="dialog">
      <v-card-title class="pa-0">
        <v-toolbar flat :class="isImporting ? 'blue darken-2 white--text' : 'primary amber blue-grey--text text--darken-4'">
          <v-toolbar-title class="headline">{{ isImporting ? 'ライブラリ' : 'フライト' }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn depressed v-if="!isImporting"
            color="black amber--text"
            :disabled="isLoading"
            @click.stop="openMedia"><font-awesome-icon :icon="['fas', 'file-import']"></font-awesome-icon>&nbsp;関連ファイルを登録する</v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="px-0">
        <v-container grid-list-md class="pa-0">
          <v-window v-model="config.page.pane">
            <v-window-item value="list">
              <v-form ref="form" v-model="form.valid" lazy-validation>
                <v-tabs
                  v-model="config.page.tab"
                  background-color="primary"
                >
                  <v-tab class="font-weight-bold" ripple>予約</v-tab>
                  <v-tab class="font-weight-bold" ripple>ファイナル</v-tab>
                  <v-tab class="font-weight-bold" ripple>関連ファイル</v-tab>
                  <v-tab-item class="px-4 py-2">
                    <v-card flat>
                      <v-row dense>
                        <v-col cols="12">
                          <v-textarea outline counter
                            name="comment-area"
                            label="予約内容"
                            height="300px"
                            hint="予約確認Eメールは関連ファイルに登録してください"
                            v-model="form.comment"
                            :rules="rules.comment"
                          />
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item class="px-4 py-2">
                    <v-card flat>
                      <v-row dense>
                        <v-col cols="12">
                          <v-menu lazy offset-y full-width
                            v-model="config.datepickers.date"
                            transition="scale-transition"
                            min-width="290px"
                            :close-on-content-click="false"
                            :nudge-right="40"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field readonly
                                v-model="printFormDate"
                                label="ファイナル期日"
                                v-on="on"
                              />
                            </template>
                            <v-date-picker
                              v-model="form.final.date"
                              locale="ja"
                              color="amber"
                              :day-format="date => new Date(date).getUTCDate()"
                              @input="config.datepickers.date = false"
                            />
                          </v-menu>
                        </v-col>
                        <v-col cols="12">
                          <v-checkbox
                            v-model="form.final.done"
                            label="ファイナル完了"
                            color="blue darken-2"
                          />
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item class="px-4 py-2">
                    <v-card flat>
                      <v-row dense>
                        <ClientFiler ref="list"
                          :items="getItems"
                          :showOnlyItems="true"
                          @select="selectUnimports"
                        />
                      </v-row>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-form>
            </v-window-item>
            <v-window-item value="filer">
              <v-row dense>
                <ClientFiler v-if="getMediaId" ref="filer"
                  :rid="getMediaId"
                  :filters="{ ids: getImportedIds }"
                  @select="selectImports"
                />
              </v-row>
            </v-window-item>
          </v-window>
        </v-container>
      </v-card-text>
      <v-card-actions v-if="isImporting">
        <v-btn text color="secondary" @click="closeMedia">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" @click="importMedia" :loading="isLoading" :disabled="!form.import">登録する</v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="isMediaPage"
          depressed
          class="mr-4"
          color="red white--text"
          @click="unimportMedia"
          :loading="isLoading"
          :disabled="!form.unimport"
        >解除する</v-btn>
        <v-btn depressed color="secondary" @click="submit" :loading="isLoading">保存する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ClientFiler from '@/components/filers/client'
export default {
  name: 'authorProgsModalsFlight',
  components: {
    ClientFiler
  },
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          importing: false
        },
        page: {
          tab: 0,
          pane: 'list'
        },
        datepickers: {
          date: false
        }
      },
      meta: {
      },
      form: {
        valid: true,
        id: '',
        cid: '',
        clientId: '',
        mid: '',
        comment: '',
        final: {
          date: '',
          done: ''
        },
        import: false,
        unimport: false
      },
      store: {
        lib: {},
        items: [],
        imports: [],
        unimports: []
      },
      rules: {
        comment: [
          v => v.length <= 250 || '最大250文字です'
        ],
        type: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'progs/update/item/meta', {
            id: this.form.id,
            cid: this.form.cid,
            type: 'flight',
            form: {
              content: this.form.comment,
              option: {
                media: this.form.mid,
                final: this.form.final
              }
            }
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('done', {
                id: this.form.cid,
                type: 'flight',
                value: {
                  content: this.form.comment,
                  option: {
                    media: this.form.mid,
                    final: {
                      date: this.form.final.date,
                      done: this.form.final.done
                    }
                  }
                }
              })
              this.close()
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    open: function (val) {
      const { id, cid, clientId, authed, comment, final } = val
      this.$set(this.config.status, 'active', true)
      this.$set(this, 'form', {
        valid: true,
        id: id,
        cid: cid,
        clientId: clientId,
        authed: authed,
        comment: comment,
        final: final,
        import: false
      })
      this.$set(this.config.page, 'tab', 0)
      this.$set(this.config.page, 'pane', 'list')
      if (id) {
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.renewItems(token, cid)
          this.renewLibIds(token, clientId)
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$set(this.store, 'lib', {})
      }
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    renewLibIds: function (token, cid) {
      this.axios.post(`${this.$url.api}box/get/root/${cid}`, {
      }, {
        headers: {
          'firebase-token': token
        }
      }).then(res => {
        console.log(res)
        if (res.data && res.data.success) {
          this.$set(this.store, 'lib', res.data.data)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    renewItems: function (token, aid) {
      this.axios.post(`${this.$url.api}progs/get/flight/media/${aid}`, {
      }, {
        headers: {
          'firebase-token': token
        }
      }).then(res => {
        console.log(res)
        if (res.data && res.data.success) {
          this.$set(this.store, 'items', res.data.data)
        }
      })
    },
    openMedia: function () {
      this.$set(this.config.status, 'importing', true)
      this.$set(this.config.page, 'pane', 'filer')
      this.$nextTick(() => {
        this.$refs.filer.init()
      })
    },
    closeMedia: function () {
      this.$set(this.config.status, 'importing', false)
      this.$set(this.config.page, 'pane', 'list')
    },
    selectImports: function (items) {
      let selects = items ? items.filter(it => {
        return (it.id && it.type && it.type !== 'folder')
      }) : []
      this.$set(this.store, 'imports', selects)
      this.$set(this.form, 'import', !!selects.length)
    },
    selectUnimports: function (items) {
      let selects = items ? items.filter(it => {
        return (it.id && it.type && it.type !== 'folder')
      }) : []
      this.$set(this.store, 'unimports', selects)
      this.$set(this.form, 'unimport', !!selects.length)
    },
    importMedia: function () {
      if (this.form.import && this.store.imports.length) {
        this.$set(this.config.status, 'loading', true)
        if (this.store.imports.length) {
          this.$firebase.auth().currentUser.getIdToken(true).then(token => {
            this.axios.post(`${this.$url.api}progs/insert/flight/media/${this.form.cid}`, { items: this.store.imports }, {
              headers: {
                'firebase-token': token
              }
            }).then(res => {
              console.log(res)
              this.renewItems(token, this.form.cid)
              this.$set(this.config.status, 'loading', false)
              this.closeMedia()
            }).catch(err => {
              console.log(err)
            })
          })
        }
      }
    },
    unimportMedia: function () {
      if (this.form.unimport && this.store.unimports.length) {
        if (this.store.unimports.length) {
          const mids = this.store.unimports.map(it => { return it.id })
          const uids = this.store.items.filter(it => { return mids.includes(it.id) }).map(it => { return it.uid })
          const { cid } = this.form
          this.$set(this.config.status, 'loading', true)
          this.$firebase.auth().currentUser.getIdToken(true).then(token => {
            this.axios.post(`${this.$url.api}progs/delete/flight/media`, { cid, uids }, {
              headers: {
                'firebase-token': token
              }
            }).then(res => {
              console.log(res)
              this.renewItems(token, this.form.cid)
              this.$set(this.config.status, 'loading', false)
            }).catch(err => {
              console.log(err)
            })
          })
        }
      }
    }
  },
  computed: {
    isActive () {
      return this.config.status.active
    },
    isLoading () {
      return this.config.status.loading
    },
    isAuthed () {
      return this.form.authed
    },
    isImporting () {
      return this.config.status.importing
    },
    isMediaPage () {
      return this.config.page.tab === 2
    },
    isSetMediaId () {
      return this.store.lib.media
    },
    printFormDate () {
      return (this.form.final && this.form.final.date) ? this.$moment(this.form.final.date).format('YYYY/MM/DD') : ''
    },
    getItems () {
      return this.store.items
    },
    getImportedIds () {
      return this.store.items.map(it => {
        return it.id
      })
    },
    getMediaId () {
      return this.store.lib.media
    }
  }
}
</script>
